export enum AIframeAspectRatio {
  Ratio1x1 = '1:1',
  Ratio3x2 = '3:2',
  Ratio16x9 = '16:9',
  Ratio5x2 = '5:2',
  Ratio2x3 = '2:3',
}

export interface AIframeProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
  url: string;
  aspectRatio?: AIframeAspectRatio;
}
